import React, { useState } from "react";
import { fetchData } from "../common/networkRequests";

import { getRequiredField, showFilter, handleFilter, checkIfFastpathAllowed, setCookie, startFaviconSpin, stopFaviconSpin } from "./commonFunctions"
import { RelevantIcon } from "./RelevantIcon";
import requiredFields from "./requiredFields";





export const ClickableIcon = ({ action, style = {}, icon, current }) => {

  let [isloading, setisloading] = useState(false);
  let [issent, setissent] = useState(false);

  const iconfunctions = {
    sendsummary: () => {
      setisloading(true);
      setTimeout(() => {
        setisloading(false);
        setissent(true);
      }, 1000);
    },
    sendfollowupsms: () => {
      setisloading(true);
      setTimeout(() => {
        setisloading(false);
        setissent(true);
      }, 1000);
    }
  }
  if (isloading) {
    return <RelevantIcon className="flash animated infinite" color="gray" icon={icon} current={current} />
  }
  else if (issent) {
    return <RelevantIcon icon="tick" style={{ color: "green" }} current={current} />
  }
  else {
    return <RelevantIcon className={action ? "hand" : ""} style={style} onClick={iconfunctions[action]} icon={icon} current={current} />
  }
}

export const handlePageChange = async ({ item, current }) => {
  let lgs = current.props.liftGlobalState;
  for (var k in requiredFields) {
    delete (requiredFields[k]);
  }
  setCookie("requiredFields", JSON.stringify({}));

  let { LocalVars, pageData, formElements, currentPage } = current.props.parentState;
  let { authenticated, token } = current.props.parentProps.parentState;
  let { defaultPage } = formElements[item.fastpath];

  if (!defaultPage) {
    LocalVars.showFilter = true;
    LocalVars.ShowHistory = true;
  } else {
    LocalVars.showFilter = false;
    LocalVars.ShowHistory = false;
  }


  lgs({ name: "LocalVars" }, LocalVars);


  let notifications = { value: "Changing page. Please Wait. . . ", alertType: "message" };
  lgs({ name: 'notifications' }, notifications);

  let response = await checkIfFastpathAllowed({ searched: item.fastpath, current });
  let { results, exceptions, error, success, proceed, pagename, limits } = response;


  if (success && proceed) {
    lgs({ name: "alerts" }, []);
    lgs({ name: "notifications" }, []);
    lgs({ name: "pageData" }, {});
    lgs({ name: "errorMessages" }, {});
    lgs({ name: 'notifications' }, {});
    lgs({ name: 'OriginalData' }, []);
    lgs({ name: 'OriginalData' }, []);
    lgs({ name: 'timeTaken' }, false);
    lgs({ name: "pageLimits" }, limits);



    //eslint-disable-next-line
    history.pushState(null, '', '/' + item.fastpath);

    current.props.liftGlobalState({ name: "leftSidebarLevel" }, 1);
    // current.props.liftWrapperState({ name: "currentPage" }, item.fastpath);
    current.props.liftGlobalState({ name: "currentPageLabel" }, item.label);
    current.props.liftGlobalState({ name: "currentPage" }, item.fastpath);

  } else {
    alert("Action is not allowed");
    try {
      this.clearNotification();
    } catch (e) { }
  }

}

export const handleConfirmSubmit = async ({ current, otherPageData, act }) => {
  let lgs = current.props.liftGlobalState;
  let {
    alerts,
    unsavedChanges,
    errorMessages,
    currentPage,
    pageData,
    LocalVars,
    formElements,
    notifications,
    remoteip,
    fileFolder
  } = current.props.parentState;
  lgs({ name: 'isSubmitting' }, true);
  lgs({ name: 'startingPage' }, 0);


  let { visitingBranches } = formElements[currentPage];
  let selectedTourBranch = LocalVars['selectedTourBranch']
  if (visitingBranches) {
    pageData['branch_uid'] = LocalVars['selectedTourBranch'].value;
    if (selectedTourBranch.more_1) {
      pageData['more_1'] = selectedTourBranch.more_1;
    }
  }

  currentPage = currentPage.toLowerCase();
  const formDefinition = formElements[currentPage]["form"];
  let shouldProceed = true;
  let errors = [];
  // !errorMessages && (errorMessages = {Login :"Login Error"}); 

  for (var i = 0; i < formDefinition.length; i++) {
    let shouldRender = 1;
    let component = formDefinition[i];
    if (component.parents) {
      for (var j = 0; j < component.parents.length; j++) {
        let elem = component.parents[j];

        const parentVal = current.props.parentState.pageData[elem.name];

        if (
          elem.reverse &&
          ((elem.match === "exist" && parentVal) ||
            (elem.match === "value" && parentVal == elem.value))
        ) {
          shouldRender = 0;
          errors.push("1");
        } else if (
          !elem.reverse &&
          ((elem.match === "exist" && parentVal) ||
            (elem.match === "value" && parentVal == elem.value))
        ) {
          shouldRender = 1;
        } else {
          if (!elem.reverse) {
            shouldRender = 0;
          }
        }
      }
    }
  }

  // Check if all the fields in requiredFields have been filled. If not, check whether allowPartialSubmit is true for the page.
  let pdt = current.props.parentState.pageData ? JSON.parse(JSON.stringify(current.props.parentState.pageData)) : {};
  // getRequiredField({ shouldProceed: false, current });
  let error_message = "There are errors on the form shown in RED color.";
  let reason;
  if (act == 'delete') {
    reason = prompt("Enter reason for deletion.");
    if (!reason) {
      shouldProceed = false;
      error_message = "Deletion reason is mandatory.";
    }
  }


  if (shouldProceed) {
    // Clean all form values to be saved in saveThis by removing unnecessary values.
    currentPage = currentPage.toLowerCase();
    const formDefinition = formElements[currentPage]["form"];
    let { token, } = current.props.parentProps.parentState;

    let saveThis = {};
    saveThis['pageData'] = pdt;
    saveThis['currentPage'] = currentPage;


    // print message if no connection. After check if it is saved locally then dont show the message again.
    unsavedChanges.push(1);
    alerts.unshift({
      value:
        String(unsavedChanges.length) +
        " Changes made but not saved yet. Don't close this window.",
      alertType: "warning"
    });

    // lgs({ name: "alerts" }, alerts); NO NEED to lift the state !!!!
    // formSubmittedClass="animated zoomOut"; BUT cant do this, because its NOT object. So the following line is necessary.

    // LocalVars["formSubmittedClass"] = "animated zoomOut";
    lgs({ name: "LocalVars" }, LocalVars);


    // Clear form - restore default values for that form after submitting.
    let defaultFormData = {};
    ;
    current.setState({ isSubmit: true });

    let CBSurl = `${remoteip}/sentry`;
    let url = CBSurl;
    let method = 'post';

    // saveThis['vendorSpecific']={};

    if (act == 'accept' || act == 'revert') {
      //if revert, remark in popup.
      saveThis['pageData']['auth_action'] = act;
      act = 'update';
    }
    saveThis['dataType'] = act;


    for (var key in otherPageData) {
      saveThis['pageData'][key] = otherPageData[key];
    }
    saveThis['deletion_reason'] = reason;

    // save data to local file as a copy.

    // check if allTabs has flattened tab. Then convert to array.


    let response = await fetchData({ url, postData: saveThis, method, current, headers: { Authorization: `JWT ${current.props.parentProps.parentState.token}` } });
    lgs({ name: 'isSubmitting' }, false);

    let { results, exceptions, error } = response;
    console.log({ error })

    if (!response || response == "") {
      notifications = { value: "Can not connect to the main server", alertType: "error" };
      lgs({ name: 'notifications' }, notifications);
      current.setState({ isSubmit: false });

      lgs({ name: "alerts" }, alerts);
      LocalVars["formSubmittedClass"] = "";
      lgs({ name: "LocalVars" }, LocalVars);
      let buttontype = { submit: false, search: false, edit: false }
      setTimeout(function () {
        lgs({ name: "alerts" }, []);
        lgs({ name: "showButtons" }, buttontype);
      }, 500);
    }
    else if (response == 'jwt expired' || response == 'jwt malformed') {
      notifications = { value: "Session expired", alertType: "error" };
      lgs({ name: 'notifications' }, notifications);
      setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
    }
    else if (error) {
      let perr = "";
      if (error.message) {
        perr = error.message.replace("_", " ");
      } else {
        perr = "Can not connect to the main server";
      }
      notifications = { value: ` ${error.code ? 'Error No:' + error.code + '.' : ''} ${perr}`, alertType: "error" };
      lgs({ name: 'notifications' }, notifications);
      current.setState({ isSubmit: false });

      lgs({ name: "alerts" }, alerts);
      LocalVars["formSubmittedClass"] = "";
      lgs({ name: "LocalVars" }, LocalVars);
      let buttontype = { submit: false, search: false, edit: false }
      setTimeout(function () {
        lgs({ name: "alerts" }, []);
        lgs({ name: "showButtons" }, buttontype);
      }, 500);
    } else if (results) {
      if (results[0] && results[0].failed) {
        notifications = { value: results[0].msg, alertType: "warning" };
        lgs({ name: 'notifications' }, notifications);
      } else {
        lgs({ name: "alerts" }, alerts);
        LocalVars["formSubmittedClass"] = "";
        lgs({ name: "LocalVars" }, LocalVars);

        showFilter({ current, act: 'show' });
        notifications = { value: "Success", alertType: "message" };
        lgs({ name: 'notifications' }, notifications);
        if (fileFolder.isOpen) {
          current.props.liftGlobalState({ name: "fileFolder" }, { isOpen: false, recordID: "", isClosing: false });
          // current.props.liftGlobalState({ name: "OriginalData" }, []);
        }
        // if identi, close the tab.
        let { identi } = current.props.parentProps.parentState;
        if (identi) {
          window.close();
        }
      }
    }
    else if (exceptions) {
      if (Object.keys(exceptions).length != 0) {
        alerts.unshift({ value: exceptions.message, alertType: "danger" })
        current.setState({ isSubmit: false });
        if (exceptions.message.includes("The user has been logged off.") == true) {
          setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
        }
      } else {
        // alerts.unshift({value:"Data save successfully",alertType: "success"})
        LocalVars["formSubmittedClass"] = "";
        let buttontype = { submit: false, search: false, edit: false }
        lgs({ name: "LocalVars" }, LocalVars);
        lgs({ name: 'pageData' }, {});
        lgs({ name: "alerts" }, []);
        lgs({ name: "showButtons" }, buttontype);
      }
      lgs({ name: "alerts" }, alerts);
      lgs({ name: "unsavedChanges" }, []);
      let buttontype = { submit: false, search: false, edit: false }

      setTimeout(function () {
        lgs({ name: "alerts" }, []);
        lgs({ name: 'pageData' }, {});
        lgs({ name: "showButtons" }, buttontype);
      }, 500);
    }
    current.setState({ isSubmit: false });
    current.setState({ submitConfirm: false });

  } else {
    alerts.unshift({
      value: error_message,
      alertType: "danger"
    });
    lgs({ name: "alerts" }, alerts);
    current.setState({ submitConfirm: false })
  }
}




export const showFileFolder = async (recordID, current) => {
  // console.log("showFileFolder")
  let lgs = current.props.liftGlobalState;
  let {
    currentPage, localpage,
    pageData, notifications, fileFolder, remoteip
  } = current.props.parentState;
  if (localpage) {
    currentPage = localpage;
  }
  let { token } = current.props.parentProps.parentState;

  pageData['unique_id'] = recordID.unique_id ? recordID.unique_id : recordID.uid;
  pageData['notify_user'] = recordID.notify_user;
  pageData['reverted'] = recordID.reverted;

  let editThis = { token, dataType: 'edit', pageData, currentPage }
  current.props.liftGlobalState({ name: 'globalFormActions' }, {})
  // if(currentPage=='notf'){
  //   let fastpath=recordID.fastpath.toLowerCase()
  //   console.log(fastpath)
  //   editThis={ token, dataType: 'edit', pageData, currentPage: fastpath}
  //   current.props.liftWrapperState({name:'currentPage'},fastpath);
  //   current.props.liftGlobalState({name:'currentPage'},fastpath);
  // }
  // console.log({ recordID })

  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let method = 'post';
  notifications = { value: "Loading...Please wait", alertType: "message" };
  current.props.liftGlobalState({ name: 'notifications' }, notifications);
  let response = await fetchData({ url, postData: editThis, method, headers: { Authorization: `JWT ${token}` } });
  // console.log({results, exceptions, error })
  let { results, exceptions, error } = response;
  if (response == 'jwt expired' || response == 'jwt malformed') {
    notifications = { value: "Session expired", alertType: "error" };
    lgs({ name: 'notifications' }, notifications);
    setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
  }
  else if (error) {
    notifications = { value: "Can not connect to the main server", alertType: "error" };
    current.props.liftGlobalState({ name: 'notifications' }, notifications);
    // this.setState({ isSearch: false });
  } else {
    if (exceptions && Object.keys(exceptions).length > 0) {
      fileFolder.isOpen = false;
      notifications = { value: exceptions.message, alertType: "error" };
      current.props.liftGlobalState({ name: 'notifications' }, notifications);

      let errorM = exceptions.message
      if (errorM.includes("The user has been logged off.") == true) {
        setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
      }
    } else {
      // save originalData to pageDataOrig also. 

      let returnData = results[0];
      if (!returnData['unique_id']) {
        if (recordID.unique_id) { returnData['unique_id'] = recordID.unique_id; }
      }
      if (!returnData['guid']) {
        if (recordID.guid) { returnData['guid'] = recordID.guid; }
      }

      current.props.liftGlobalState({ name: "pageData" }, returnData);
      // Do reverse search for all the affected controls.      

      if (!current.props.parentState.fileFolder.isOpen && recordID && recordID.unique_id) {
        fileFolder.isOpen = true;
        fileFolder.recordID = recordID.unique_id;
        //   fileFolder.formState = "view"; // Set default state to read only

        current.props.liftGlobalState({ name: "fileFolder" }, fileFolder);
        current.props.liftGlobalState({ name: 'notifications' }, {});
      }
      current.props.liftGlobalState({ name: 'notifications' }, {});
    }

  }
}

export const handleSearch = async ({ current, pageData, loadOnly }) => {
  let {
    alerts,
    unsavedChanges,
    errorMessages,
    currentPage,
    remoteip,
    LocalVars, localpage,
    formElements, notifications, openmodals,
    showButtons,
    historyTableParams,
    startingUID,
    openControls
  } = current.props.parentState;

  let lgs = current.props.liftGlobalState;

  let { visitingBranches } = formElements[currentPage];
  let selectedTourBranch = LocalVars['selectedTourBranch'];
  if (visitingBranches) {
    // if (['cash_verifications'].indexOf(currentPage) != -1) {
    //   pageData['CashVerification-branch-branch_uid'] = selectedTourBranch.value;
    // } else {
    pageData['branch_uid'] = selectedTourBranch.value;
    // console.log({ selectedTourBranch })
    if (selectedTourBranch.more_1) {
      pageData['more_1'] = selectedTourBranch.more_1;
    }
    // }
  }

  let { token } = current.props.parentProps.parentState;

  lgs({ name: 'OriginalData' }, []);

  if (openControls.length > 0) {
    currentPage = openControls[openControls.length - 1]['fastpath'];
    pageData = openControls[openControls.length - 1]['values'] ? openControls[openControls.length - 1]['values'] : {};
    openControls[openControls.length - 1]['isSearching'] = true;
    lgs({ name: 'openControls' }, openControls);
  } else {
    lgs({ name: 'isSearching' }, true);
  }
  startFaviconSpin();

  let { limitresults } = historyTableParams;
  pageData.limitresults = limitresults;

  if (openControls[openControls.length - 1]) {
    pageData['controlfastpath'] = { target: openControls[openControls.length - 1].target, orig_fastpath: openControls[openControls.length - 1].orig_fastpath };
  }

  let searchThis = { currentPage, pageData, dataType: "search" };

  let shouldProceed = true;
  let errors = [];
  // current.setState({ isSearch: true });
  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let method = 'post';

  // lgs({ name: 'notifications' }, notifications);
  let response = await fetchData({ url, postData: searchThis, method, headers: { Authorization: `JWT ${token}` }, current });
  if (openControls.length > 0) {
    openControls[openControls.length - 1]['isSearching'] = false;
    lgs({ name: 'openControls' }, openControls);
  } else {
    lgs({ name: 'isSearching' }, false);
  }
  // stop spinning favicon.
  stopFaviconSpin();
  let { results, exceptions, error, timeTaken, searchTime, success, cached } = response;

  if (success) {

    let { LocalVars } = current.props.parentState;
    lgs({ name: "timeTaken" }, timeTaken);

    LocalVars["searchTime"] = searchTime;
    LocalVars["ShowHistory"] = true;

    let reportData = [];

    if (loadOnly) {
      //CAVEAT/REASON: useMemo updates values only if object changes with its reference, not just values in it.
      // e.g. table doesnt update if = is used. .concat creates new object.
      reportData = reportData.concat(new Object(current.props.parentState.OriginalData));
    }

    let allids = [0]; let x;
    for (var k in results) {
      reportData.push(results[k]);
      results[k].id ? allids.push(results[k].id) : x = 0;
    }
    let maxid = Math.max(allids);
    lgs({ name: 'maxid' }, { [currentPage]: maxid });


    // lgs({ name: 'notifications' }, []);
    if (cached && cached.message) {
      notifications = { value: cached.message, alertType: "success" };
      lgs({ name: 'notifications' }, notifications);
    } else {
      lgs({ name: 'notifications' }, []);
    }


    if (openControls.length > 0) {
      openControls[openControls.length - 1]['data'] = reportData;
      openControls[openControls.length - 1]['LocalVars'] = LocalVars;
      lgs({ name: 'openControls' }, openControls);
    } else {
      lgs({ name: "LocalVars" }, LocalVars);
      lgs({ name: 'OriginalData' }, reportData);
    }
  }
}